import { helpers, ValidationRule } from 'vuelidate/lib/validators';

export const personalCodeRegex: ValidationRule = helpers.regex('personalCodeRegex', /^\d{11}$/);
export const phoneRegex: ValidationRule = helpers.regex('phoneRegex', /^( *)?[+]?[0-9]+( *)?$/);
export const emailRegex: ValidationRule = helpers.regex('emailRegex', /^( *)?.+@.+\..+( *)?$/);
export const latinOnlyRegex: ValidationRule = helpers.regex('personalCodeRegex', /^[a-zA-ZõäöüšžÕÄÖÜŠŽ ]+$/);
